var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdResource } from "../../constants/IdResource";
import { NonBuyableResources } from "../../constants/NonBuyableResources";
import { IdStyles } from "../../less/IdStyles";
import { selectNotEnoughResources, selectNotEnoughResourceTotalGoldCost, } from "../../selectors/selectNotEnoughResources";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonDefault } from "../generic/button-buy/ButtonDefault";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { componentWithProps } from "../generic/componentWithProps";
import { IdIcon } from "../generic/icon/IdIcon";
import { ResourceBar } from "../generic/resource-bar/ResourceBar";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalCloseAll, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionShowMeQuestTaskCollectResource } from "../show-me/actionShowMe";
import { actionSelectTournamentDialog } from "../tournament-building/actionTournament";
import { actionNotEnoughResourceBuyWithGold, actionNotEnoughResourceCancel, } from "./actionNotEnoughResource";
import { ButtonShowMeNotEnoughResources } from "./ButtonShowMeNotEnoughResources";
import { IdMissingResourceTypes } from "./IdMissingResourceTypes";
import { MissingResources } from "./MissingResources";
var DialogNotEnoughResourceDOM = /** @class */ (function (_super) {
    __extends(DialogNotEnoughResourceDOM, _super);
    function DialogNotEnoughResourceDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDialogContents = function () {
            var actualResourceType = _this.getMissingType();
            var onShowMeTournamentCoins = _this.props.onShowMeTournamentCoins;
            switch (actualResourceType) {
                case IdMissingResourceTypes.Resources:
                    return {
                        description: IdLoca.notEnoughResourcesDialog_desc,
                        resourceButton: _this.getResourceButton(),
                        title: IdLoca.notEnoughResourcesDialog_title,
                    };
                case IdMissingResourceTypes.Dollar:
                    return {
                        description: IdLoca.notEnoughResourcesDialog_desc,
                        resourceButton: _this.getResourceButton(),
                        title: IdLoca.notEnoughResourcesDialog_title,
                    };
                case IdMissingResourceTypes.Gold:
                    return {
                        description: IdLoca.notEnoughGoldDialog_desc,
                        resourceButton: React.createElement(React.Fragment, null),
                        title: IdLoca.notEnoughGoldDialog_title,
                    };
                case IdMissingResourceTypes.ShopMaterials:
                    return {
                        description: IdLoca.notEnoughMaterialsDialog_desc,
                        resourceButton: React.createElement(React.Fragment, null),
                        title: IdLoca.notEnoughMaterialsDialog_title,
                    };
                case IdMissingResourceTypes.NonBuyable:
                    return {
                        description: IdLoca.notEnoughResourcesDialog_desc2,
                        resourceButton: React.createElement(React.Fragment, null),
                        title: IdLoca.notEnoughResourcesDialog_title,
                    };
                case IdMissingResourceTypes.TournamentCoins:
                    return {
                        description: IdLoca.help_notEnoughTournamentCoins_desc,
                        resourceButton: (React.createElement(ButtonPrimary, { onClick: onShowMeTournamentCoins },
                            React.createElement(TextLoca, { id: IdLoca.showMe, className: IdStyles.TextButtonDefault }))),
                        title: IdLoca.help_notEnoughTournamentCoins_title,
                    };
            }
        };
        _this.onClickHandleAction = function () {
            var _a = _this.props, onBuyWithGold = _a.onBuyWithGold, missingResources = _a.missingResources, onBuyGold = _a.onBuyGold;
            var actualResourceType = _this.getMissingType();
            if (actualResourceType === IdMissingResourceTypes.Gold) {
                onBuyGold();
            }
            else if (actualResourceType === IdMissingResourceTypes.ShopMaterials) {
                return;
            }
            else {
                onBuyWithGold(missingResources);
            }
        };
        _this.getResourceButton = function () {
            var totalGoldCost = _this.props.totalGoldCost;
            if (!totalGoldCost || totalGoldCost.equals(Long.ZERO)) {
                return undefined;
            }
            return (React.createElement(ButtonDefault, { onClick: _this.onClickHandleAction, component: ButtonSecondary, amount: totalGoldCost, icon: IdIcon.GoldIcn }));
        };
        _this.getMissingType = function () {
            var _a = _this.props.notEnoughResourceInfo, missingResources = _a.missingResources, resourceType = _a.resourceType;
            if (_this.hasTournamentCoins(missingResources)) {
                return IdMissingResourceTypes.TournamentCoins;
            }
            if (_this.hasNonBuyableResources(missingResources)) {
                return IdMissingResourceTypes.NonBuyable;
            }
            return _this.hasShopOnlyResources(missingResources)
                ? IdMissingResourceTypes.ShopMaterials
                : resourceType;
        };
        _this.hasShopOnlyResources = function (resources) {
            return !resources.every(function (value) {
                var isOnlyFromOffer = value.resource.onlyFromOffer !== undefined;
                var hasGoldValue = !!value.resource.goldValue;
                var isGold = value.resource.id === IdResource.Gold;
                return isGold || (!isOnlyFromOffer && hasGoldValue);
            });
        };
        _this.hasNonBuyableResources = function (resources) {
            return resources.find(function (value) {
                return value.resource.type !== undefined &&
                    NonBuyableResources.indexOf(value.resource.type) >= 0;
            }) !== undefined;
        };
        _this.hasTournamentCoins = function (resources) {
            return resources.find(function (value) {
                return value.resource.id !== undefined && value.resource.id === IdResource.TournamentCoins;
            });
        };
        return _this;
    }
    DialogNotEnoughResourceDOM.prototype.render = function () {
        var _a = this.props, missingResources = _a.notEnoughResourceInfo.missingResources, onShowMeCollectResource = _a.onShowMeCollectResource;
        var dialogInfo = this.getDialogContents();
        var footerResources = [IdResource.Money, IdResource.Gold];
        var footerComponent = componentWithProps({
            ComponentType: ResourceBar,
            resources: footerResources,
        });
        return (React.createElement(DialogWrapper, { titleLocaId: dialogInfo.title, onClose: this.props.onClose, className: IdStyles.ModalBackgroundResources, footerRenderer: footerComponent },
            React.createElement("div", { className: "not-enough-dialog-content" },
                React.createElement("div", { className: IdStyles.TextBoldPrimary },
                    React.createElement(TextLoca, { id: dialogInfo.description })),
                React.createElement(MissingResources, { missingResources: missingResources }),
                React.createElement("div", { className: "button-ribbon" },
                    React.createElement(ButtonShowMeNotEnoughResources, { missingResources: missingResources, onClick: onShowMeCollectResource }),
                    dialogInfo.resourceButton))));
    };
    return DialogNotEnoughResourceDOM;
}(React.Component));
var mapState = function (state) {
    var notEnoughResourceInfo = selectNotEnoughResources(state);
    var totalGoldCost = selectNotEnoughResourceTotalGoldCost(notEnoughResourceInfo);
    var missingResources = notEnoughResourceInfo.missingResources.map(function (cost) {
        return {
            amount: cost.missing,
            typeId: cost.resource.id,
        };
    });
    return {
        missingResources: missingResources,
        notEnoughResourceInfo: notEnoughResourceInfo,
        totalGoldCost: totalGoldCost,
    };
};
var mapDispatch = function (dispatch) { return ({
    onBuyGold: function () {
        dispatch(actionModalCloseAll());
        dispatch(actionModalOpen(IdModal.Shop));
    },
    onBuyWithGold: function (missingResources) {
        return dispatch(actionNotEnoughResourceBuyWithGold(missingResources));
    },
    onClose: function () { return dispatch(actionNotEnoughResourceCancel()); },
    onShowMeCollectResource: function (taskType) {
        return dispatch(actionShowMeQuestTaskCollectResource(taskType));
    },
    onShowMeTournamentCoins: function () {
        dispatch(actionModalCloseAll());
        dispatch(actionSelectTournamentDialog());
    },
}); };
export var DialogNotEnoughResource = connect(mapState, mapDispatch)(DialogNotEnoughResourceDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/DialogNotEnoughResource.tsx
// module id = 2850
// module chunks = 3